export default {"src":"/_next/static/media/enerflo-integrations-icon.e70d52dc.svg","height":49,"width":55};